// extracted by css-extract-rspack-plugin
export default {"Butterfly":"Butterfly-module__Butterfly__M9CcLO6"};